export const products = [
  {
    id: 'genshin',
    name: '原神',
    image: 'https://public.readdy.ai/ai/img_res/17c3893398de81fd3dd3c33bd80f5783.jpg',
    price: 'NT$ 27 起',
    originalPrice: 'NT$ 30',
    discount: '全站 9 折',
    badge: '熱門🔥',
    link: '/order',
    denominations: [
      { amount: '60 創世結晶', original: 30, price: 27 },
      { amount: '300 創世結晶', original: 150, price: 135 },
      { amount: '980 創世結晶', original: 490, price: 441 },
      { amount: '1980 創世結晶', original: 980, price: 882 },
      { amount: '3280 創世結晶', original: 1640, price: 1476 },
      { amount: '6480 創世結晶', original: 3240, price: 2916 },
    ]
  },
  {
    id: 'honkai-star-rail',
    name: '崩壞：星穹鐵道',
    image: 'https://readdy.ai/api/search-image?query=Honkai%20Star%20Rail%20game%20official%20artwork%20with%20space%20train%20Astral%20Express%20and%20anime%20characters%20in%20cosmic%20galaxy%20theme%2C%20clean%20simple%20gradient%20background%20in%20purple%20and%20blue%20starry%20tones%2C%20professional%20game%20promotional%20poster%20design%20with%20sci-fi%20atmosphere&width=400&height=500&seq=prod2&orientation=portrait',
    price: 'NT$ 27 起',
    originalPrice: 'NT$ 30',
    discount: '全站 9 折',
    badge: '熱門🔥',
    link: '/order',
    denominations: [
      { amount: '60 星瓊', original: 30, price: 27 },
      { amount: '300 星瓊', original: 150, price: 135 },
      { amount: '980 星瓊', original: 490, price: 441 },
      { amount: '1980 星瓊', original: 980, price: 882 },
      { amount: '3280 星瓊', original: 1640, price: 1476 },
      { amount: '6480 星瓊', original: 3240, price: 2916 },
    ]
  },
  {
    id: 'zenless-zone-zero',
    name: '絕區零',
    image: 'https://readdy.ai/api/search-image?query=Zenless%20Zone%20Zero%20game%20official%20artwork%20with%20urban%20cyberpunk%20anime%20characters%20in%20neon%20city%20street%2C%20clean%20simple%20gradient%20background%20in%20electric%20teal%20and%20dark%20purple%20tones%2C%20professional%20game%20promotional%20poster%20design%20with%20futuristic%20atmosphere&width=400&height=500&seq=prod3&orientation=portrait',
    price: 'NT$ 27 起',
    originalPrice: 'NT$ 30',
    discount: '全站 9 折',
    badge: '新品✨',
    link: '/order',
    denominations: [
      { amount: '60 菲林', original: 30, price: 27 },
      { amount: '300 菲林', original: 150, price: 135 },
      { amount: '980 菲林', original: 490, price: 441 },
      { amount: '1980 菲林', original: 980, price: 882 },
      { amount: '3280 菲林', original: 1640, price: 1476 },
      { amount: '6480 菲林', original: 3240, price: 2916 },
    ]
  },
  {
    id: 'wuthering-waves',
    name: '鳴潮',
    image: 'https://readdy.ai/api/search-image?query=Wuthering%20Waves%20game%20official%20artwork%20with%20fantasy%20anime%20characters%20and%20mystical%20water%20elements%20in%20epic%20scene%2C%20clean%20simple%20gradient%20background%20in%20turquoise%20teal%20and%20white%20tones%2C%20professional%20game%20promotional%20poster%20design%20with%20magical%20atmosphere&width=400&height=500&seq=prod4&orientation=portrait',
    price: 'NT$ 27 起',
    originalPrice: 'NT$ 30',
    discount: '全站 9 折',
    badge: '熱門🔥',
    link: '/order',
    denominations: [
      { amount: '60 潮汐', original: 30, price: 27 },
      { amount: '300 潮汐', original: 150, price: 135 },
      { amount: '980 潮汐', original: 490, price: 441 },
      { amount: '1980 潮汐', original: 980, price: 882 },
      { amount: '3280 潮汐', original: 1640, price: 1476 },
      { amount: '6480 潮汐', original: 3240, price: 2916 },
    ]
  },
  {
    id: 'honor-of-kings',
    name: '王者榮耀',
    image: 'https://readdy.ai/api/search-image?query=Honor%20of%20Kings%20game%20official%20artwork%20with%20legendary%20heroes%20warriors%20in%20epic%20battle%20formation%2C%20clean%20simple%20gradient%20background%20in%20royal%20gold%20and%20crimson%20red%20tones%2C%20professional%20game%20promotional%20poster%20design%20with%20heroic%20atmosphere&width=400&height=500&seq=prod5&orientation=portrait',
    price: 'NT$ 45 起',
    originalPrice: 'NT$ 50',
    discount: '全站 9 折',
    badge: '熱門🔥',
    link: '/order',
    denominations: [
      { amount: '100 點券', original: 50, price: 45 },
      { amount: '300 點券', original: 150, price: 135 },
      { amount: '600 點券', original: 300, price: 270 },
      { amount: '1280 點券', original: 640, price: 576 },
      { amount: '3280 點券', original: 1640, price: 1476 },
      { amount: '6480 點券', original: 3240, price: 2916 },
    ]
  },
  {
    id: 'pubg-mobile',
    name: 'PUBG Mobile',
    image: 'https://readdy.ai/api/search-image?query=PUBG%20Mobile%20game%20official%20artwork%20with%20tactical%20soldiers%20in%20battle%20royale%20action%20scene%20with%20weapons%2C%20clean%20simple%20gradient%20background%20in%20military%20olive%20green%20and%20orange%20sunset%20tones%2C%20professional%20game%20promotional%20poster%20design%20with%20intense%20atmosphere&width=400&height=500&seq=prod6&orientation=portrait',
    price: 'NT$ 27 起',
    originalPrice: 'NT$ 30',
    discount: '全站 9 折',
    badge: '熱門🔥',
    link: '/order',
    denominations: [
      { amount: '60 UC', original: 30, price: 27 },
      { amount: '325 UC', original: 150, price: 135 },
      { amount: '660 UC', original: 300, price: 270 },
      { amount: '1800 UC', original: 800, price: 720 },
      { amount: '3850 UC', original: 1600, price: 1440 },
      { amount: '8100 UC', original: 3200, price: 2880 },
    ]
  },
  {
    id: 'arena-of-valor',
    name: '傳說對決',
    image: 'https://readdy.ai/api/search-image?query=Arena%20of%20Valor%20game%20official%20artwork%20with%20fantasy%20heroes%20champions%20in%20dynamic%20combat%20pose%2C%20clean%20simple%20gradient%20background%20in%20electric%20blue%20and%20gold%20tones%2C%20professional%20game%20promotional%20poster%20design%20with%20epic%20atmosphere&width=400&height=500&seq=prod7&orientation=portrait',
    price: 'NT$ 27 起',
    originalPrice: 'NT$ 30',
    discount: '全站 9 折',
    link: '/order',
    denominations: [
      { amount: '60 點券', original: 30, price: 27 },
      { amount: '310 點券', original: 150, price: 135 },
      { amount: '630 點券', original: 300, price: 270 },
      { amount: '1580 點券', original: 750, price: 675 },
      { amount: '3280 點券', original: 1500, price: 1350 },
      { amount: '6560 點券', original: 3000, price: 2700 },
    ]
  },
  {
    id: 'wild-rift',
    name: '英雄聯盟：激鬥峽谷',
    image: 'https://readdy.ai/api/search-image?query=League%20of%20Legends%20Wild%20Rift%20game%20official%20artwork%20with%20champions%20heroes%20in%20epic%20battle%20formation%20with%20magical%20effects%2C%20clean%20simple%20gradient%20background%20in%20royal%20blue%20and%20gold%20tones%2C%20professional%20game%20promotional%20poster%20design%20with%20legendary%20atmosphere&width=400&height=500&seq=prod8&orientation=portrait',
    price: 'NT$ 27 起',
    originalPrice: 'NT$ 30',
    discount: '全站 9 折',
    badge: '熱門🔥',
    link: '/order',
    denominations: [
      { amount: '60 聯盟幣', original: 30, price: 27 },
      { amount: '335 聯盟幣', original: 150, price: 135 },
      { amount: '690 聯盟幣', original: 300, price: 270 },
      { amount: '1850 聯盟幣', original: 800, price: 720 },
      { amount: '3900 聯盟幣', original: 1600, price: 1440 },
      { amount: '8150 聯盟幣', original: 3200, price: 2880 },
    ]
  },
  {
    id: 'arknights',
    name: '明日方舟',
    image: 'https://readdy.ai/api/search-image?query=Arknights%20game%20official%20artwork%20with%20anime%20tactical%20operators%20in%20military%20formation%20with%20Rhodes%20Island%20logo%2C%20clean%20simple%20gradient%20background%20in%20dark%20navy%20blue%20and%20white%20tones%2C%20professional%20game%20promotional%20poster%20design%20with%20strategic%20atmosphere&width=400&height=500&seq=prod9&orientation=portrait',
    price: 'NT$ 27 起',
    originalPrice: 'NT$ 30',
    discount: '全站 9 折',
    badge: '熱門🔥',
    link: '/order',
    denominations: [
      { amount: '60 合成玉', original: 30, price: 27 },
      { amount: '330 合成玉', original: 150, price: 135 },
      { amount: '680 合成玉', original: 300, price: 270 },
      { amount: '1680 合成玉', original: 750, price: 675 },
      { amount: '3480 合成玉', original: 1500, price: 1350 },
      { amount: '6980 合成玉', original: 3000, price: 2700 },
    ]
  },
  {
    id: 'nikke',
    name: '勝利女神：妮姬',
    image: 'https://readdy.ai/api/search-image?query=Goddess%20of%20Victory%20NIKKE%20game%20official%20artwork%20with%20beautiful%20anime%20girls%20in%20futuristic%20sci-fi%20armor%20with%20weapons%2C%20clean%20simple%20gradient%20background%20in%20hot%20pink%20and%20purple%20tones%2C%20professional%20game%20promotional%20poster%20design%20with%20stylish%20atmosphere&width=400&height=500&seq=prod10&orientation=portrait',
    price: 'NT$ 27 起',
    originalPrice: 'NT$ 30',
    discount: '全站 9 折',
    badge: '熱門🔥',
    link: '/order',
    denominations: [
      { amount: '60 寶石', original: 30, price: 27 },
      { amount: '300 寶石', original: 150, price: 135 },
      { amount: '980 寶石', original: 490, price: 441 },
      { amount: '1980 寶石', original: 980, price: 882 },
      { amount: '3280 寶石', original: 1640, price: 1476 },
      { amount: '6480 寶石', original: 3240, price: 2916 },
    ]
  },
  {
    id: 'azur-lane',
    name: '碧藍航線',
    image: 'https://readdy.ai/api/search-image?query=Azur%20Lane%20game%20official%20artwork%20with%20anime%20shipgirls%20in%20naval%20battle%20scene%20on%20ocean%20waves%2C%20clean%20simple%20gradient%20background%20in%20ocean%20blue%20and%20white%20tones%2C%20professional%20game%20promotional%20poster%20design%20with%20maritime%20atmosphere&width=400&height=500&seq=prod11&orientation=portrait',
    price: 'NT$ 27 起',
    originalPrice: 'NT$ 30',
    discount: '全站 9 折',
    link: '/order',
    denominations: [
      { amount: '60 鑽石', original: 30, price: 27 },
      { amount: '300 鑽石', original: 150, price: 135 },
      { amount: '980 鑽石', original: 490, price: 441 },
      { amount: '1980 鑽石', original: 980, price: 882 },
      { amount: '3280 鑽石', original: 1640, price: 1476 },
      { amount: '6480 鑽石', original: 3240, price: 2916 },
    ]
  },
  {
    id: 'delta-force',
    name: '三角洲行動',
    image: 'https://readdy.ai/api/search-image?query=Delta%20Force%20game%20official%20artwork%20with%20tactical%20special%20forces%20soldiers%20in%20modern%20warfare%20combat%20scene%20with%20military%20equipment%2C%20clean%20simple%20gradient%20background%20in%20military%20grey%20and%20orange%20explosion%20tones%2C%20professional%20game%20promotional%20poster%20design%20with%20intense%20atmosphere&width=400&height=500&seq=prod12&orientation=portrait',
    price: 'NT$ 27 起',
    originalPrice: 'NT$ 30',
    discount: '全站 9 折',
    badge: '新品✨',
    link: '/order',
    denominations: [
      { amount: '60 D幣', original: 30, price: 27 },
      { amount: '300 D幣', original: 150, price: 135 },
      { amount: '980 D幣', original: 490, price: 441 },
      { amount: '1980 D幣', original: 980, price: 882 },
      { amount: '3280 D幣', original: 1640, price: 1476 },
      { amount: '6480 D幣', original: 3240, price: 2916 },
    ]
  },
  {
    id: 'zombie-shooter',
    name: '向殭屍開炮',
    image: 'https://readdy.ai/api/search-image?query=Zombie%20shooting%20tower%20defense%20mobile%20game%20artwork%20with%20colorful%20cartoon%20cannon%20firing%20at%20horde%20of%20zombies%20on%20grassy%20battlefield%2C%20bright%20playful%20illustration%20style%20with%20clean%20gradient%20background%20in%20lush%20green%20and%20warm%20orange%20tones%2C%20energetic%20fun%20mobile%20game%20promotional%20poster%20with%20cheerful%20atmosphere%20and%20comic%20action%20effects&width=400&height=500&seq=prod13&orientation=portrait',
    price: 'NT$ 27 起',
    originalPrice: 'NT$ 30',
    discount: '全站 9 折',
    badge: '新品✨',
    link: '/order',
    denominations: [
      { amount: '60 鑽石', original: 30, price: 27 },
      { amount: '300 鑽石', original: 150, price: 135 },
      { amount: '980 鑽石', original: 490, price: 441 },
      { amount: '1980 鑽石', original: 980, price: 882 },
      { amount: '3280 鑽石', original: 1640, price: 1476 },
      { amount: '6480 鑽石', original: 3240, price: 2916 },
    ]
  },
  {
    id: 'lord-of-destruction',
    name: '破壞之主',
    image: 'https://readdy.ai/api/search-image?query=Lord%20of%20Destruction%20dark%20fantasy%20mobile%20game%20artwork%20with%20powerful%20demon%20lord%20in%20dark%20armor%20surrounded%20by%20destruction%20flames%20and%20ruins%2C%20epic%20dark%20fantasy%20illustration%20with%20clean%20gradient%20background%20in%20deep%20crimson%20red%20and%20black%20tones%2C%20dramatic%20mobile%20game%20promotional%20poster%20with%20sinister%20powerful%20atmosphere%20and%20fiery%20effects&width=400&height=500&seq=prod14&orientation=portrait',
    price: 'NT$ 27 起',
    originalPrice: 'NT$ 30',
    discount: '全站 9 折',
    badge: '新品✨',
    link: '/order',
    denominations: [
      { amount: '60 寶石', original: 30, price: 27 },
      { amount: '300 寶石', original: 150, price: 135 },
      { amount: '980 寶石', original: 490, price: 441 },
      { amount: '1980 寶石', original: 980, price: 882 },
      { amount: '3280 寶石', original: 1640, price: 1476 },
      { amount: '6480 寶石', original: 3240, price: 2916 },
    ]
  },
  {
    id: 'paladin-new-beginning',
    name: '仙劍奇俠傳：新的開始',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20Paladin%20Xian%20Jian%20Qi%20Xia%20Zhuan%20new%20beginning%20mobile%20game%20artwork%20with%20elegant%20ancient%20Chinese%20swordsman%20and%20sorceress%20in%20flowing%20robes%20surrounded%20by%20mystical%20crane%20birds%20and%20mountain%20scenery%2C%20beautiful%20wuxia%20illustration%20with%20clean%20gradient%20background%20in%20jade%20green%20and%20celestial%20white%20tones%2C%20stunning%20Chinese%20fantasy%20mobile%20game%20promotional%20poster%20with%20immortal%20ethereal%20atmosphere&width=400&height=500&seq=prod15&orientation=portrait',
    price: 'NT$ 27 起',
    originalPrice: 'NT$ 30',
    discount: '全站 9 折',
    badge: '熱門🔥',
    link: '/order',
    denominations: [
      { amount: '60 仙石', original: 30, price: 27 },
      { amount: '300 仙石', original: 150, price: 135 },
      { amount: '980 仙石', original: 490, price: 441 },
      { amount: '1980 仙石', original: 980, price: 882 },
      { amount: '3280 仙石', original: 1640, price: 1476 },
      { amount: '6480 仙石', original: 3240, price: 2916 },
    ]
  },
  {
    id: 'oddbods-patroller',
    name: '怪咖糾察隊',
    image: 'https://readdy.ai/api/search-image?query=Oddbods%20quirky%20colorful%20cartoon%20characters%20mobile%20game%20artwork%20with%20funny%20round%20bean-shaped%20creatures%20in%20patrol%20squad%20uniforms%20on%20city%20street%2C%20bright%20vivid%20illustration%20with%20clean%20gradient%20background%20in%20electric%20yellow%20and%20sky%20blue%20tones%2C%20playful%20cheerful%20mobile%20game%20promotional%20poster%20with%20fun%20comedic%20atmosphere%20and%20bold%20comic%20style&width=400&height=500&seq=prod16&orientation=portrait',
    price: 'NT$ 27 起',
    originalPrice: 'NT$ 30',
    discount: '全站 9 折',
    link: '/order',
    denominations: [
      { amount: '60 金幣', original: 30, price: 27 },
      { amount: '300 金幣', original: 150, price: 135 },
      { amount: '980 金幣', original: 490, price: 441 },
      { amount: '1980 金幣', original: 980, price: 882 },
      { amount: '3280 金幣', original: 1640, price: 1476 },
      { amount: '6480 金幣', original: 3240, price: 2916 },
    ]
  },
  {
    id: 'pokemon-tcg-pocket',
    name: 'Pokémon TCG Pocket',
    image: 'https://readdy.ai/api/search-image?query=Pokemon%20Trading%20Card%20Game%20Pocket%20mobile%20game%20artwork%20with%20Pikachu%20and%20legendary%20Pokemon%20characters%20surrounded%20by%20glowing%20holographic%20trading%20cards%20in%20magical%20sparkle%20effects%2C%20vibrant%20colorful%20illustration%20with%20clean%20gradient%20background%20in%20warm%20golden%20yellow%20and%20electric%20red%20tones%2C%20exciting%20Pokemon%20card%20game%20promotional%20poster%20with%20nostalgic%20magical%20atmosphere%20and%20card%20burst%20effects&width=400&height=500&seq=prod17&orientation=portrait',
    price: 'NT$ 27 起',
    originalPrice: 'NT$ 30',
    discount: '全站 9 折',
    badge: '熱門🔥',
    link: '/order',
    denominations: [
      { amount: '60 寶可幣', original: 30, price: 27 },
      { amount: '300 寶可幣', original: 150, price: 135 },
      { amount: '980 寶可幣', original: 490, price: 441 },
      { amount: '1980 寶可幣', original: 980, price: 882 },
      { amount: '3280 寶可幣', original: 1640, price: 1476 },
      { amount: '6480 寶可幣', original: 3240, price: 2916 },
    ]
  },
  {
    id: 'twilight-twin-cities',
    name: '暮色雙城',
    image: 'https://readdy.ai/api/search-image?query=Twilight%20twin%20cities%20fantasy%20mobile%20game%20artwork%20with%20two%20magnificent%20kingdoms%20facing%20each%20other%20across%20mystical%20twilight%20sky%20with%20aurora%20colors%2C%20beautiful%20concept%20art%20illustration%20with%20clean%20gradient%20background%20in%20rich%20amber%20orange%20and%20deep%20violet%20tones%2C%20atmospheric%20RPG%20mobile%20game%20promotional%20poster%20with%20mysterious%20romantic%20twilight%20atmosphere%20and%20castle%20silhouettes&width=400&height=500&seq=prod18&orientation=portrait',
    price: 'NT$ 27 起',
    originalPrice: 'NT$ 30',
    discount: '全站 9 折',
    badge: '新品✨',
    link: '/order',
    denominations: [
      { amount: '60 月光石', original: 30, price: 27 },
      { amount: '300 月光石', original: 150, price: 135 },
      { amount: '980 月光石', original: 490, price: 441 },
      { amount: '1980 月光石', original: 980, price: 882 },
      { amount: '3280 月光石', original: 1640, price: 1476 },
      { amount: '6480 月光石', original: 3240, price: 2916 },
    ]
  },
  {
    id: 'lord-rush',
    name: '主公衝衝衝',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20lord%20strategy%20mobile%20game%20artwork%20with%20heroic%20ancient%20Chinese%20warlord%20riding%20battle%20horse%20leading%20army%20charge%20across%20vast%20battlefield%20with%20flags%20and%20war%20drums%2C%20dynamic%20action%20illustration%20with%20clean%20gradient%20background%20in%20bold%20scarlet%20red%20and%20golden%20yellow%20tones%2C%20epic%20strategy%20mobile%20game%20promotional%20poster%20with%20heroic%20intense%20battle%20atmosphere%20and%20Chinese%20historical%20style&width=400&height=500&seq=prod19&orientation=portrait',
    price: 'NT$ 27 起',
    originalPrice: 'NT$ 30',
    discount: '全站 9 折',
    link: '/order',
    denominations: [
      { amount: '60 元寶', original: 30, price: 27 },
      { amount: '300 元寶', original: 150, price: 135 },
      { amount: '980 元寶', original: 490, price: 441 },
      { amount: '1980 元寶', original: 980, price: 882 },
      { amount: '3280 元寶', original: 1640, price: 1476 },
      { amount: '6480 元寶', original: 3240, price: 2916 },
    ]
  },
  {
    id: 'call-me-officer',
    name: '叫我官老爺',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20ancient%20official%20governor%20mobile%20game%20artwork%20with%20wealthy%20dignified%20mandarin%20official%20in%20ornate%20imperial%20robes%20sitting%20in%20grand%20government%20hall%20with%20servants%20and%20treasure%2C%20luxurious%20humorous%20illustration%20with%20clean%20gradient%20background%20in%20imperial%20gold%20and%20vermilion%20red%20tones%2C%20charming%20Chinese%20historical%20simulation%20mobile%20game%20promotional%20poster%20with%20comedic%20prosperous%20atmosphere&width=400&height=500&seq=prod20&orientation=portrait',
    price: 'NT$ 27 起',
    originalPrice: 'NT$ 30',
    discount: '全站 9 折',
    link: '/order',
    denominations: [
      { amount: '60 銀兩', original: 30, price: 27 },
      { amount: '300 銀兩', original: 150, price: 135 },
      { amount: '980 銀兩', original: 490, price: 441 },
      { amount: '1980 銀兩', original: 980, price: 882 },
      { amount: '3280 銀兩', original: 1640, price: 1476 },
      { amount: '6480 銀兩', original: 3240, price: 2916 },
    ]
  },
  {
    id: 'sanguo-yunmeng',
    name: '三國雲夢錄',
    image: 'https://readdy.ai/api/search-image?query=Three%20Kingdoms%20Sanguo%20Yunmeng%20mobile%20game%20artwork%20with%20iconic%20warlords%20Cao%20Cao%20Liu%20Bei%20Sun%20Quan%20in%20epic%20battle%20tableau%20surrounded%20by%20misty%20ink%20wash%20mountains%20and%20dramatic%20clouds%2C%20stunning%20Chinese%20classical%20painting%20style%20illustration%20with%20clean%20gradient%20background%20in%20misty%20cerulean%20blue%20and%20antique%20gold%20tones%2C%20majestic%20Three%20Kingdoms%20mobile%20game%20promotional%20poster%20with%20grand%20historical%20atmosphere&width=400&height=500&seq=prod21&orientation=portrait',
    price: 'NT$ 27 起',
    originalPrice: 'NT$ 30',
    discount: '全站 9 折',
    badge: '熱門🔥',
    link: '/order',
    denominations: [
      { amount: '60 玉璧', original: 30, price: 27 },
      { amount: '300 玉璧', original: 150, price: 135 },
      { amount: '980 玉璧', original: 490, price: 441 },
      { amount: '1980 玉璧', original: 980, price: 882 },
      { amount: '3280 玉璧', original: 1640, price: 1476 },
      { amount: '6480 玉璧', original: 3240, price: 2916 },
    ]
  },
  {
    id: 'dragon-soul-traveler',
    name: '龍魂旅人',
    image: 'https://readdy.ai/api/search-image?query=Dragon%20Soul%20Traveler%20mobile%20game%20artwork%20with%20brave%20adventurer%20riding%20majestic%20eastern%20dragon%20through%20fantastical%20world%20with%20floating%20islands%20and%20glowing%20ancient%20ruins%2C%20vibrant%20fantasy%20illustration%20with%20clean%20gradient%20background%20in%20fiery%20dragon%20red%20and%20celestial%20teal%20tones%2C%20adventurous%20RPG%20mobile%20game%20promotional%20poster%20with%20epic%20journey%20magical%20atmosphere%20and%20dragon%20scale%20textures&width=400&height=500&seq=prod22&orientation=portrait',
    price: 'NT$ 27 起',
    originalPrice: 'NT$ 30',
    discount: '全站 9 折',
    badge: '新品✨',
    link: '/order',
    denominations: [
      { amount: '60 龍晶', original: 30, price: 27 },
      { amount: '300 龍晶', original: 150, price: 135 },
      { amount: '980 龍晶', original: 490, price: 441 },
      { amount: '1980 龍晶', original: 980, price: 882 },
      { amount: '3280 龍晶', original: 1640, price: 1476 },
      { amount: '6480 龍晶', original: 3240, price: 2916 },
    ]
  },
  {
    id: 'egg-treasure-story',
    name: '蛋寶物語',
    image: 'https://readdy.ai/api/search-image?query=Egg%20treasure%20story%20cute%20mobile%20game%20artwork%20with%20adorable%20round%20egg%20monster%20characters%20in%20colorful%20magical%20world%20with%20candy%20trees%20and%20rainbow%20landscape%2C%20super%20kawaii%20anime%20illustration%20with%20clean%20gradient%20background%20in%20pastel%20pink%20and%20mint%20green%20tones%2C%20charming%20cute%20mobile%20game%20promotional%20poster%20with%20sweet%20cheerful%20atmosphere%20and%20sparkle%20effects%20all%20around&width=400&height=500&seq=prod23&orientation=portrait',
    price: 'NT$ 27 起',
    originalPrice: 'NT$ 30',
    discount: '全站 9 折',
    link: '/order',
    denominations: [
      { amount: '60 寶石', original: 30, price: 27 },
      { amount: '300 寶石', original: 150, price: 135 },
      { amount: '980 寶石', original: 490, price: 441 },
      { amount: '1980 寶石', original: 980, price: 882 },
      { amount: '3280 寶石', original: 1640, price: 1476 },
      { amount: '6480 寶石', original: 3240, price: 2916 },
    ]
  },
  {
    id: 'douluo-shrek',
    name: '斗羅大陸：史萊克學院',
    image: 'https://readdy.ai/api/search-image?query=Douluo%20Continent%20Shrek%20Academy%20mobile%20game%20artwork%20with%20powerful%20young%20soul%20masters%20in%20vibrant%20spirit%20power%20battle%20poses%20with%20colorful%20spirit%20beast%20companion%20animals%20and%20academy%20building%20in%20background%2C%20dynamic%20anime%20illustration%20with%20clean%20gradient%20background%20in%20royal%20spirit%20power%20blue%20and%20shining%20gold%20tones%2C%20epic%20cultivation%20mobile%20game%20promotional%20poster%20with%20youthful%20powerful%20academy%20atmosphere&width=400&height=500&seq=prod24&orientation=portrait',
    price: 'NT$ 27 起',
    originalPrice: 'NT$ 30',
    discount: '全站 9 折',
    badge: '熱門🔥',
    link: '/order',
    denominations: [
      { amount: '60 魂幣', original: 30, price: 27 },
      { amount: '300 魂幣', original: 150, price: 135 },
      { amount: '980 魂幣', original: 490, price: 441 },
      { amount: '1980 魂幣', original: 980, price: 882 },
      { amount: '3280 魂幣', original: 1640, price: 1476 },
      { amount: '6480 魂幣', original: 3240, price: 2916 },
    ]
  },
  {
    id: 'minotaur-go',
    name: '牛頭人 GO',
    image: 'https://readdy.ai/api/search-image?query=Minotaur%20GO%20augmented%20reality%20mobile%20game%20artwork%20with%20cartoon%20bull%20minotaur%20character%20appearing%20in%20real%20city%20street%20through%20AR%20phone%20screen%2C%20colorful%20playful%20illustration%20with%20clean%20gradient%20background%20in%20vivid%20orange%20and%20bright%20turquoise%20tones%2C%20fun%20location%20based%20mobile%20game%20promotional%20poster%20with%20adventurous%20playful%20AR%20exploration%20atmosphere&width=400&height=500&seq=prod25&orientation=portrait',
    price: 'NT$ 27 起',
    originalPrice: 'NT$ 30',
    discount: '全站 9 折',
    link: '/order',
    denominations: [
      { amount: '60 角幣', original: 30, price: 27 },
      { amount: '300 角幣', original: 150, price: 135 },
      { amount: '980 角幣', original: 490, price: 441 },
      { amount: '1980 角幣', original: 980, price: 882 },
      { amount: '3280 角幣', original: 1640, price: 1476 },
      { amount: '6480 角幣', original: 3240, price: 2916 },
    ]
  },
  {
    id: 'block-blast',
    name: 'Block Blast!',
    image: 'https://readdy.ai/api/search-image?query=Block%20Blast%20puzzle%20mobile%20game%20artwork%20with%20colorful%203D%20geometric%20blocks%20exploding%20and%20disappearing%20from%20a%20grid%20board%20in%20satisfying%20chain%20reaction%2C%20bright%20minimalist%20illustration%20with%20clean%20gradient%20background%20in%20vivid%20coral%20red%20and%20bright%20yellow%20tones%2C%20addictive%20casual%20puzzle%20mobile%20game%20promotional%20poster%20with%20satisfying%20clean%20modern%20design%20and%20explosive%20block%20effects&width=400&height=500&seq=prod26&orientation=portrait',
    price: 'NT$ 27 起',
    originalPrice: 'NT$ 30',
    discount: '全站 9 折',
    link: '/order',
    denominations: [
      { amount: '60 金幣', original: 30, price: 27 },
      { amount: '300 金幣', original: 150, price: 135 },
      { amount: '980 金幣', original: 490, price: 441 },
      { amount: '1980 金幣', original: 980, price: 882 },
      { amount: '3280 金幣', original: 1640, price: 1476 },
      { amount: '6480 金幣', original: 3240, price: 2916 },
    ]
  },
  {
    id: 'fengshen-rush',
    name: '咻咻封神',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20mythology%20Fengshen%20deification%20mobile%20game%20artwork%20with%20legendary%20immortal%20warrior%20flying%20with%20divine%20thunder%20and%20mystical%20deity%20creatures%20from%20Journey%20to%20the%20Investiture%20of%20Gods%2C%20colorful%20energetic%20illustration%20with%20clean%20gradient%20background%20in%20heavenly%20celestial%20gold%20and%20lightning%20yellow%20tones%2C%20exciting%20Chinese%20mythology%20action%20mobile%20game%20promotional%20poster%20with%20divine%20powerful%20atmosphere&width=400&height=500&seq=prod27&orientation=portrait',
    price: 'NT$ 27 起',
    originalPrice: 'NT$ 30',
    discount: '全站 9 折',
    badge: '新品✨',
    link: '/order',
    denominations: [
      { amount: '60 仙玉', original: 30, price: 27 },
      { amount: '300 仙玉', original: 150, price: 135 },
      { amount: '980 仙玉', original: 490, price: 441 },
      { amount: '1980 仙玉', original: 980, price: 882 },
      { amount: '3280 仙玉', original: 1640, price: 1476 },
      { amount: '6480 仙玉', original: 3240, price: 2916 },
    ]
  },
  {
    id: 'dawn-blood-witch',
    name: '黎明：血色魔女',
    image: 'https://readdy.ai/api/search-image?query=Dawn%20Bloody%20Witch%20dark%20fantasy%20mobile%20game%20artwork%20with%20powerful%20enchanting%20female%20witch%20sorceress%20in%20crimson%20bloodstained%20dress%20casting%20dark%20magic%20spells%20in%20gothic%20moonlit%20forest%2C%20moody%20dark%20illustration%20with%20clean%20gradient%20background%20in%20blood%20crimson%20red%20and%20midnight%20black%20tones%2C%20atmospheric%20dark%20fantasy%20mobile%20game%20promotional%20poster%20with%20mysterious%20dangerous%20gothic%20atmosphere&width=400&height=500&seq=prod28&orientation=portrait',
    price: 'NT$ 27 起',
    originalPrice: 'NT$ 30',
    discount: '全站 9 折',
    badge: '新品✨',
    link: '/order',
    denominations: [
      { amount: '60 血晶', original: 30, price: 27 },
      { amount: '300 血晶', original: 150, price: 135 },
      { amount: '980 血晶', original: 490, price: 441 },
      { amount: '1980 血晶', original: 980, price: 882 },
      { amount: '3280 血晶', original: 1640, price: 1476 },
      { amount: '6480 血晶', original: 3240, price: 2916 },
    ]
  },
  {
    id: 'shanhaijing-mutation',
    name: '新山海經：異變',
    image: 'https://readdy.ai/api/search-image?query=New%20Classic%20of%20Mountains%20and%20Seas%20mutation%20mobile%20game%20artwork%20with%20bizarre%20mythological%20creatures%20from%20Chinese%20Shanhaijing%20with%20glowing%20mutant%20features%20in%20ancient%20scroll%20art%20style%20illustration%2C%20exotic%20mystical%20illustration%20with%20clean%20gradient%20background%20in%20ancient%20ink%20black%20and%20mystical%20emerald%20green%20tones%2C%20fascinating%20Chinese%20mythology%20mobile%20game%20promotional%20poster%20with%20mysterious%20ancient%20bestiary%20atmosphere&width=400&height=500&seq=prod29&orientation=portrait',
    price: 'NT$ 27 起',
    originalPrice: 'NT$ 30',
    discount: '全站 9 折',
    badge: '新品✨',
    link: '/order',
    denominations: [
      { amount: '60 靈玉', original: 30, price: 27 },
      { amount: '300 靈玉', original: 150, price: 135 },
      { amount: '980 靈玉', original: 490, price: 441 },
      { amount: '1980 靈玉', original: 980, price: 882 },
      { amount: '3280 靈玉', original: 1640, price: 1476 },
      { amount: '6480 靈玉', original: 3240, price: 2916 },
    ]
  },
  {
    id: 'miracle-blood-dancer',
    name: '神蹟：血舞者',
    image: 'https://readdy.ai/api/search-image?query=Miracle%20blood%20dancer%20fantasy%20mobile%20game%20artwork%20with%20graceful%20yet%20deadly%20female%20dancer%20warrior%20in%20elegant%20crimson%20costume%20spinning%20with%20blood-red%20energy%20ribbons%20and%20magical%20power%20in%20dramatic%20arena%2C%20breathtaking%20fantasy%20illustration%20with%20clean%20gradient%20background%20in%20vivid%20scarlet%20red%20and%20deep%20royal%20gold%20tones%2C%20spectacular%20fantasy%20mobile%20game%20promotional%20poster%20with%20sensational%20elegant%20warrior%20atmosphere&width=400&height=500&seq=prod30&orientation=portrait',
    price: 'NT$ 27 起',
    originalPrice: 'NT$ 30',
    discount: '全站 9 折',
    badge: '熱門🔥',
    link: '/order',
    denominations: [
      { amount: '60 神石', original: 30, price: 27 },
      { amount: '300 神石', original: 150, price: 135 },
      { amount: '980 神石', original: 490, price: 441 },
      { amount: '1980 神石', original: 980, price: 882 },
      { amount: '3280 神石', original: 1640, price: 1476 },
      { amount: '6480 神石', original: 3240, price: 2916 },
    ]
  },
  {
    id: 'new-paladin-sword-romance',
    name: '新仙劍奇俠傳之揮劍問情',
    image: 'https://readdy.ai/api/search-image?query=New%20Legend%20of%20Sword%20and%20Fairy%20Chinese%20RPG%20mobile%20game%20artwork%20with%20a%20heroic%20young%20swordsman%20and%20beautiful%20fairy%20maiden%20in%20flowing%20silk%20robes%20standing%20together%20under%20blossoming%20peach%20tree%20on%20misty%20mountain%20cliff%2C%20romantic%20wuxia%20illustration%20with%20clean%20gradient%20background%20in%20cherry%20blossom%20pink%20and%20misty%20mountain%20white%20tones%2C%20emotionally%20moving%20Chinese%20fantasy%20mobile%20game%20promotional%20poster%20with%20bittersweet%20romantic%20swordsman%20atmosphere&width=400&height=500&seq=prod31&orientation=portrait',
    price: 'NT$ 27 起',
    originalPrice: 'NT$ 30',
    discount: '全站 9 折',
    badge: '熱門🔥',
    link: '/order',
    denominations: [
      { amount: '60 仙石', original: 30, price: 27 },
      { amount: '300 仙石', original: 150, price: 135 },
      { amount: '980 仙石', original: 490, price: 441 },
      { amount: '1980 仙石', original: 980, price: 882 },
      { amount: '3280 仙石', original: 1640, price: 1476 },
      { amount: '6480 仙石', original: 3240, price: 2916 },
    ]
  },
  {
    id: 'archero-2',
    name: '弓箭傳說 2',
    image: 'https://readdy.ai/api/search-image?query=Archero%202%20mobile%20game%20artwork%20with%20heroic%20lone%20archer%20character%20firing%20rapid%20arrows%20through%20dungeon%20filled%20with%20monsters%20in%20satisfying%20auto-battle%20roguelike%20scene%2C%20vibrant%20pixel%20art%20inspired%20illustration%20with%20clean%20gradient%20background%20in%20forest%20emerald%20green%20and%20warm%20amber%20tones%2C%20addictive%20action%20roguelike%20mobile%20game%20promotional%20poster%20with%20intense%20progression%20satisfying%20combat%20atmosphere&width=400&height=500&seq=prod32&orientation=portrait',
    price: 'NT$ 27 起',
    originalPrice: 'NT$ 30',
    discount: '全站 9 折',
    badge: '熱門🔥',
    link: '/order',
    denominations: [
      { amount: '60 寶石', original: 30, price: 27 },
      { amount: '300 寶石', original: 150, price: 135 },
      { amount: '980 寶石', original: 490, price: 441 },
      { amount: '1980 寶石', original: 980, price: 882 },
      { amount: '3280 寶石', original: 1640, price: 1476 },
      { amount: '6480 寶石', original: 3240, price: 2916 },
    ]
  },
];

// 保留舊的分類導出以維持相容性
export const uidProducts = products.slice(0, 4);
export const hotProducts = products.slice(0, 5);
export const monthlyProducts = products.slice(8, 12);
export const specialProducts = products.slice(0, 5);
export const newProducts = [products[2], products[11], products[13], products[14], products[17], products[20], products[21], products[28]];